import React, { Component } from "react";
export default class About extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="about">
        <div className="row">
          <div className="three columns">
            <img className="profile-pic" src="images/dani.jpg" alt="" />
          </div>

          <div className="nine columns main-col">
            <h2>About Me</h2>
            <p>
              {resumeData.aboutme1}
              <a
                href="https://www.shopify.com"
                target="_blank"
                rel="noopener noreferrer"
              >
              {resumeData.aboutmelink1}
              </a>
              {resumeData.aboutme2}
            </p>
            <div className="row">
              <div className="columns contact-details">
                <h2>Want to know more?</h2>
                <p className="address">
                  <span>
                    <b>{resumeData.name}</b>
                  </span>
                  <br></br>
                  <span>{resumeData.email}</span>
                  <br></br>
                  <span>K8s Slack: {resumeData.k8s_slack}</span>
                  <br></br>
                  <span>{resumeData.address}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
